import Gecko from './gecko/gecko';
import EngageRequest from './EngageRequest';
import { $state, $stateParams } from '../router';
import RSVP_CONSTS from '../constants';
import { initTranslation, __, STR_KEY } from './Translate';
var moment = require('moment');

class RsvpService {

    parseRsvp(data) {
        
        const event = this.applyAttendanceToEvent(data.event, data.attendances);

        const sessions = data.sessions.map((session) => {
            return this.applyAttendanceToEvent(session, data.attendances);
        });

        const parsedData = {
            account: data.account,
            contact: data.contact, 
            event: event,
            events: [event],
            attendances: data.attendances,
            sessions: sessions,
            hosts: data.hosts,
            location: data.location,
        }

        parsedData.eventAttendance = data.attendances ? data.attendances.find(att => att.event_id === data.event.id) : null;
        return parsedData;
    }

    applyAttendanceToEvent(event, attendances)
    {   
        const matching_attendance = attendances.find(attendance => attendance.event_id === event.id);
        event.attendance = (matching_attendance ? matching_attendance : null);

        return event;
    }

    rfields = {
        attendance: [
            //'contact_id',
            'event_id',
            'guest_count',
            'status',
            'status_title',
            //'sync_status',
            //'synced',
            //'uuid',
            'rsvp',
            'ical', 
            'passbook', 
            // 'attendances_count',
        ],
        contact: [
            'full_name',
            'email',
            'qr_url',
            'uuid',
            'preferred_language'
        ],
        event: [
            // 'account_id',
            // 'attendances_count',
            'available_spaces',
            'checkin_start',
            // 'children_count',
            // 'children',
            // 'children_count',
            'closed',
            // 'closing_date',
            // 'contacts',
            // 'connect_id',
            // 'connect_title',
            // 'cost',
            // 'country',
            // 'created_at',
            // 'crm',
            // 'date_range',
            // 'dynamics_id',
            // 'dynamics_title',
            'description',
            // 'deleted_at',
            'end_date',
            'end_datetime',
            'full',
            'full_waitlist',
            // 'id',
            'location_title_legacy',
            'parent_id',
            // 'radius_id',
            // 'radius_title',
            // 'registration_type',
            // 'responses',
            // 'responses_count',
            'start_date',
            'start_datetime',
            // 'syncs',
            'title',
            'timezone',
            'total_attendances',
            'type',
            // 'updated_at',
            // 'users',
            'maximum',
            'maximum_guests',
            'auto_waitlist',
            'status',
            // 'children',
            // 'synced',
            // 'sync_status',
            // 'sync_progress'
        ],
        account: [
            'color',
            'header_bg',
            'header_logo',
            'uuid'
        ]
    };


    getRsvp(params) {
        const url = `/rsvp/${params.account_uuid}/${params.contact_uuid}/${params.event_id}?includes=hosts`;
        return EngageRequest.get(url).then(data => {
            return initTranslation(data.contact.preferred_language).then(() => data);
        });
    }

    resolve(req) {
        return new Promise((resolve, reject) => {
            return req.then(data => {
                console.timeEnd('TIMING:');

                resolve(data)
            }).catch(err => err.errors ? reject(err.errors): reject(err));
        });
    }

    parseEvents(data) {

        data = {
            contact: data.contact,
            account: data.contact.related_account,
            eventsActive: data.eventsActive,
            eventsPast: data.eventsPast
        };

        delete data.contact.related_account;

        return data;
    }

    getContact(params) {
        const includes = ['account'];
        const rFields = {
            contact: [
                'id',
                'full_name',
                'email',
                'qr_url',
                'uuid',
                'preferred_language'
            ],
            account: [
                'color',
                'header_bg',
                'header_logo',
                'uuid'
            ]
        };
        let req = new Gecko.Contact().include(includes).rfields(rFields).call(`/contacts/public/${params.contact_uuid}`, 'GET', {}, false);
        return this.resolve(req);
    }

    getHost(params) {
        const includes = ['account'];
        const rFields = {
            contact: [
                'full_name',
                'email',
                'qr_url',
                'uuid'
            ],
            account: [
                'color',
                'header_bg',
                'header_logo',
                'uuid'
            ]
        };
        let req = new Gecko.Contact().include(includes).rfields(rFields).call(`/contacts/public/${params.contact_uuid}`, 'GET', {}, false);
        return this.resolve(req);
    }

    getEventsActive(params) {
        const includes = ['attendances'];
        let req = new Gecko.Event().include(includes).rfields(this.rfields).where('type', [Gecko.Event.TYPE_EVENT, Gecko.Event.TYPE_EVENT_LEGACY]).call(`/events/public/${params.contact_uuid}/active`, 'GET', {}, false);
        return this.resolve(req);
    }

    getEventsPast(params) {
        const includes = ['attendances'];
        let req = new Gecko.Event().include(includes).rfields(this.rfields).where('type', [Gecko.Event.TYPE_EVENT, Gecko.Event.TYPE_EVENT_LEGACY]).call(`/events/public/${params.contact_uuid}/past`, 'GET', {}, false);
        return this.resolve(req);
    }

    updateCheckin(eventId) {
        return new Promise((resolve, reject) => {
            EngageRequest.post(`/attendances/rsvp/${$stateParams.account_uuid}/${$stateParams.contact_uuid}/${eventId}`, {per_page: 999999999, status: 30}).then(data => {
                resolve(data)
            }).catch(err => {
                console.error(err)
                return reject(err.message)
            });
        });

    } 

    updateAttendance(eventId, attending) {
        return new Promise((resolve, reject) => {
            EngageRequest.post(`/attendances/rsvp/${$stateParams.account_uuid}/${$stateParams.contact_uuid}/${eventId}`, {per_page: 999999999, attending: attending, registration_force_flags: ['closing_date']}).then(data => {
                resolve(data)
            }).catch(err => {
                console.error(err)
                return reject(err.message)
            });
        });
    }

    changeGuests(attendanceId, numberOfGuests) {
        return new Promise((resolve, reject) => {
            EngageRequest.post(`/attendances/${attendanceId}/change_guests/${$stateParams.account_uuid}/${$stateParams.contact_uuid}`, {guest_count: numberOfGuests || 0}).then(data => {
                resolve(data)
            }).catch(err => {
                console.error(err)
                return reject(err.message)
            });
        });
    }

    getEventsSessions(params) {
        let req = new Gecko.Event().call(`/rsvp/${params.account_uuid}/${params.contact_uuid}/${params.event_id}/sessions`, 'GET', {}, false);
        return this.resolve(req);
    }

    static hasEventClosed(mainEvent)
    {
        if (!mainEvent){
            return false;
        }

        if (mainEvent.closing_datetime_utc && mainEvent.closing_datetime_utc < moment().format('X')) {
            return true;
        }

        return false;
    }

    static hasEventPassed(mainEvent)
    {
        if (!mainEvent){
            return false;
        }

        if (mainEvent.end_datetime_utc && mainEvent.end_datetime_utc < moment().format('X')) {
            return true;
        }

        return false;
    }

    static isVenue = (event) => (event || {}).delivery_method === 'venue';

    static isOnline = (event) => (event || {}).delivery_method === 'online';

    static isHybrid = (event) => (event || {}).delivery_method === 'hybrid';

    static isSingleEvent = (event) => (event || {}).registration_type === RSVP_CONSTS.EVENT.TYPE_SINGLE_EVENT;

    static goToStreamPage = (eventId) => {
        return $state.go('stream', {
            account_uuid: $stateParams.account_uuid,
            contact_uuid: $stateParams.contact_uuid,
            event_id: eventId,
            env: $stateParams.env || null
        }, {reload: true});
    };

    static getPrettyDeliveryMethod = (event, isSession) => {
        let str, icon;
        if (RsvpService.isOnline(event)) {
            str = isSession ? __(STR_KEY.MISC_ONLINE_SESSION) : __(STR_KEY.MISC_ONLINE_EVENT);
            icon = 'far fa-wifi';
        } else if (RsvpService.isHybrid(event)) {
            str = isSession ? __(STR_KEY.MISC_VENUE_AND_ONLINE_SESSION) : __(STR_KEY.MISC_VENUE_AND_ONLINE_EVENT);
            icon = 'fal fa-map-marker-alt';
        } else {
            str = isSession ? __(STR_KEY.MISC_VENUE_SESSION) : __(STR_KEY.MISC_VENUE_EVENT);
            icon = 'fal fa-map-marker-alt';
        }
        return [str, icon];
    };

    static setFocusInside = (parent = '.modal') => {
        try {
            setTimeout(() => {
                const allElements = document.querySelectorAll(`${parent} input, ${parent} button, ${parent} a, ${parent} area, ${parent} object, ${parent} select, ${parent} textarea, ${parent} [contenteditable]`);
                if (allElements.length) allElements[0].focus();
            }, 300)
        } catch (err) {}        
    }

}

export default RsvpService;